class XukReveal extends HTMLElement {
  connectedCallback() {
    if (this.dataset.xukRevealReady === 'true') return;
    this.dataset.xukRevealReady = 'true';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      this.classList.add('is-visible');
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        this.classList.add('is-visible');
        this.observer.disconnect();
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('xuk-reveal')) {
  customElements.define('xuk-reveal', XukReveal);
}
